import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import { fetchPost, resetPost } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import './PostPage.css';
import Helmet from 'react-helmet';

class PostPage extends Component {

  componentDidMount()
  {
    const slug = this.props.match.params.slug;

    // Reset post page when changing content.  Reset happens before the
    // content is rendered and this avoids an ugly flash which could otherwise
    // be seen.
    if (this.props.post && this.props.post.slug !== slug) {
      this.props.resetPost()
    }

    // Fetch contents of a blog post if we don't have any data or the
    // blog address changes.  Due to the use of Router component, React will
    // not re-load page when clicking on the blog post in blog page.
    if (!this.props.post || this.props.post.slug !== slug) {
      this.props.fetchPost(slug)
    }
  }

  render() {
    let post;
    if (this.props.post) {
        post = {
            slug: this.props.post.slug,
            //image: this.props.post.image, // Leave black for now
            heading: this.props.post.title,
            lead: this.props.post.content,
        };
    }
    console.log(post);

    return (
      <div className="post" key={post ? post.slug : ''}>
        <Helmet>
          <title>{post ? post.heading : ''}</title>
        </Helmet>
        {!post && <Loader/>}
        {post && <FullbleedHero fields={post} />}
      </div>
    );
  }
}

PostPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => {
  return {
    post: state.post,
  }
};

const mapDispatchToProps = {
  fetchPost,
  resetPost,
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(PostPage));



// WEBPACK FOOTER //
// ./src/containers/PostPage.js